module.exports = __webpack_public_path__ + "static/media/group_4974.6d02f032.svg";